import { appsignal } from '@lib/appsignal';
import { ToastContext } from '@lib/context/toast.context';
import { signIn, useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import {
  type FunctionComponent,
  type PropsWithChildren,
  useContext,
} from 'react';
import { SWRConfig } from 'swr';

const SwrGlobalErrorHandler: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const { data: session } = useSession();
  const router = useRouter();
  const { addToast } = useContext(ToastContext);

  return (
    <SWRConfig
      value={{
        onError: (error, key) => {
          // console.log(error, key);
          if (error?.cause?.cause?.status === 401) {
            addToast({
              id: 'Authentication error',
              title: 'Attempting to re-authenticate',
              color: 'warning',
            });
            signIn('da', { callbackUrl: router.asPath }); // Force sign in to hopefully resolve error
            return;
          }
          const endpoint: string =
            error?.cause?.cause?.route?.split('?')?.[0] || 'unknown';

          appsignal.sendError(error, span => {
            span.setAction(`swr-global:api:${endpoint}`);
            span.setParams({
              cause: error?.cause?.cause || error,
            });
            span.setTags({
              user_darn: session?.user?.darn?.toString() ?? '',
              route: key,
            });
          });
        },
      }}>
      {children}
    </SWRConfig>
  );
};

export default SwrGlobalErrorHandler;
